<script lang="ts">
    
    import type { GameType } from "../../global";
    import { GameTypeService } from "../../Services/GameTypeService";

    export let type: GameType;

    $: text = GameTypeService.getDisplayName(type);

</script>

<slot {text}>{text}</slot>
